"use client";

import { c as _c } from "react/compiler-runtime";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FocusTrap } from "focus-trap-react";
import type { FormEvent } from "react";
import { useId, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useClickAway, useKeyPressEvent } from "react-use";
import IdentitySearch, { IdentitySearchSize } from "@/components/utils/input/identity/IdentitySearch";
export enum WaveGroupManageIdentitiesMode {
  INCLUDE = "INCLUDE",
  EXCLUDE = "EXCLUDE",
}
export interface WaveGroupManageIdentitiesConfirmEvent {
  readonly identity: string;
  readonly mode: WaveGroupManageIdentitiesMode;
}
export default function WaveGroupManageIdentitiesModal(t0) {
  const $ = _c(45);
  const {
    mode,
    onClose,
    onConfirm
  } = t0;
  const modalRef = useRef(null);
  const titleId = useId();
  const descriptionId = useId();
  useClickAway(modalRef, onClose);
  let t1;
  if ($[0] !== onClose) {
    t1 = event => {
      if (event.defaultPrevented) {
        return;
      }
      const activeElement = document.activeElement as HTMLElement | null;
      if (activeElement && modalRef.current?.contains(activeElement) && (activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA" || activeElement.tagName === "SELECT" || activeElement.isContentEditable || activeElement.getAttribute("role") === "combobox")) {
        return;
      }
      onClose();
    };
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useKeyPressEvent("Escape", t1);
  const title = mode === WaveGroupManageIdentitiesMode.INCLUDE ? "Include identity" : "Exclude identity";
  const description = mode === WaveGroupManageIdentitiesMode.INCLUDE ? "Add an identity to this group's allow list." : "Move an identity to this group's exclude list.";
  const [identity, setIdentity] = useState(null);
  const actionLabel = mode === WaveGroupManageIdentitiesMode.INCLUDE ? "Include" : "Exclude";
  let t2;
  if ($[2] !== identity || $[3] !== mode || $[4] !== onClose || $[5] !== onConfirm) {
    t2 = event_0 => {
      event_0.preventDefault();
      if (identity) {
        onConfirm({
          identity,
          mode
        });
        onClose();
      }
    };
    $[2] = identity;
    $[3] = mode;
    $[4] = onClose;
    $[5] = onConfirm;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleSubmit = t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      allowOutsideClick: true,
      fallbackFocus: () => modalRef.current ?? document.body
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="tw-fixed tw-inset-0 tw-bg-gray-500 tw-bg-opacity-75" />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== title || $[10] !== titleId) {
    t5 = <p id={titleId} className="tw-text-lg tw-font-semibold tw-text-iron-50 tw-mb-0">{title}</p>;
    $[9] = title;
    $[10] = titleId;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== description || $[13] !== descriptionId) {
    t6 = <p id={descriptionId} className="tw-text-sm tw-text-iron-400 tw-mb-0">{description}</p>;
    $[12] = description;
    $[13] = descriptionId;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <div className="tw-flex tw-flex-col tw-gap-y-2">{t5}{t6}</div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="tw-sr-only">Close</span>;
    t9 = <FontAwesomeIcon icon={faXmark} className="tw-h-5 tw-w-5" />;
    $[18] = t8;
    $[19] = t9;
  } else {
    t8 = $[18];
    t9 = $[19];
  }
  let t10;
  if ($[20] !== onClose) {
    t10 = <button onClick={onClose} type="button" aria-label="Close dialog" className="tw-p-2 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-iron-900 tw-border-0 tw-text-iron-400 hover:tw-text-iron-50 tw-transition tw-duration-300 tw-ease-out">{t8}{t9}</button>;
    $[20] = onClose;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t7) {
    t11 = <div className="tw-flex tw-justify-between tw-items-start">{t7}{t10}</div>;
    $[22] = t10;
    $[23] = t7;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== identity) {
    t12 = <div className="tw-mt-6"><IdentitySearch size={IdentitySearchSize.MD} identity={identity} setIdentity={setIdentity} autoFocus={true} label="Identity handle or address" /></div>;
    $[25] = identity;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== onClose) {
    t13 = <button onClick={onClose} type="button" className="tw-bg-iron-900 tw-px-4 tw-py-3 tw-text-sm tw-font-semibold tw-text-white tw-border tw-border-solid tw-border-iron-700 tw-rounded-lg tw-transition tw-duration-300 tw-ease-out hover:tw-bg-iron-800 hover:tw-border-iron-600">Cancel</button>;
    $[27] = onClose;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  const t14 = !identity;
  const t15 = `tw-ml-3 tw-px-4 tw-py-3 tw-text-sm tw-font-semibold tw-rounded-lg tw-border tw-border-solid tw-transition tw-duration-300 tw-ease-out ${identity ? "tw-bg-primary-500 tw-border-primary-500 tw-text-white hover:tw-bg-primary-600 hover:tw-border-primary-600" : "tw-bg-iron-800 tw-border-iron-700 tw-text-iron-400 tw-opacity-60"}`;
  let t16;
  if ($[29] !== actionLabel || $[30] !== t14 || $[31] !== t15) {
    t16 = <button type="submit" disabled={t14} className={t15}>{actionLabel}</button>;
    $[29] = actionLabel;
    $[30] = t14;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t13 || $[34] !== t16) {
    t17 = <div className="tw-mt-6 tw-flex tw-justify-end">{t13}{t16}</div>;
    $[33] = t13;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== handleSubmit || $[37] !== t12 || $[38] !== t17) {
    t18 = <form onSubmit={handleSubmit}>{t12}{t17}</form>;
    $[36] = handleSubmit;
    $[37] = t12;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== descriptionId || $[41] !== t11 || $[42] !== t18 || $[43] !== titleId) {
    t19 = createPortal(<FocusTrap focusTrapOptions={t3}><div className="tw-cursor-default tw-relative tw-z-50">{t4}<div className="tw-fixed tw-inset-0 tw-z-10 tw-overflow-y-auto"><div className="tw-flex tw-min-h-full tw-items-end tw-justify-center tw-p-4 tw-text-center sm:tw-items-center sm:tw-p-0"><dialog ref={modalRef} aria-modal="true" aria-labelledby={titleId} aria-describedby={descriptionId} tabIndex={-1} open={true} className="sm:tw-max-w-xl tw-relative tw-w-full tw-transform tw-rounded-xl tw-bg-iron-950 tw-text-left tw-shadow-xl tw-transition-all tw-duration-500 sm:tw-w-full tw-p-6">{t11}{t18}</dialog></div></div></div></FocusTrap>, document.body);
    $[40] = descriptionId;
    $[41] = t11;
    $[42] = t18;
    $[43] = titleId;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  return t19;
}